export default __webpack_public_path__ + "1ade8d640ed6bf7e007a4991c6648ab7.svg";